module.exports = __webpack_public_path__ + "static/media/licensing.e8e5ebdc.svg";